import { LatLngLiteral } from "leaflet";
import { useState } from "react";
import {
  MapContainer,
  MapContainerProps,
  Marker,
  TileLayer,
  useMapEvents,
} from "react-leaflet";
import { mapIcon } from "../../utils/mapIcon";

type PropsMaps = {
  coordinates: LatLngLiteral;
  getPosition?: (data: LatLngLiteral) => void;
  disableClick?: boolean;
} & MapContainerProps;

const ComponentMap = ({
  coordinates: coordProps,
  getPosition,
  disableClick,
}: PropsMaps) => {
  const [coordinates, setCoordinates] = useState<LatLngLiteral>({
    lat: coordProps.lat,
    lng: coordProps.lng,
  } as LatLngLiteral);

  useMapEvents({
    click: ({ latlng }) => {
      if (disableClick) return;

      const { lat, lng } = latlng;
      setCoordinates({ lat, lng });
      getPosition?.({ lat, lng });
    },
  });

  return (
    <>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {coordinates.lat !== 0 && coordinates.lng !== 0 && (
        <Marker interactive={false} icon={mapIcon} position={coordinates} />
      )}
    </>
  );
};

const Map = ({
  coordinates,
  getPosition,
  disableClick = false,
  ...rest
}: PropsMaps) => {
  return (
    <MapContainer
      center={coordinates}
      attributionControl={false}
      zoomControl={false}
      {...rest}
    >
      <ComponentMap
        getPosition={getPosition}
        coordinates={coordinates}
        disableClick={disableClick}
      />
    </MapContainer>
  );
};

export { Map };
